import { FormikErrors, useFormikContext } from 'formik';
import React from 'react';

const transformObjectToDotNotation = (
  obj: FormikErrors<any>,
  prefix = '',
  result: string[] = [],
) => {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (!value) return;

    const nextKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'object') {
      transformObjectToDotNotation(value as any, nextKey, result);
    } else {
      result.push(nextKey);
    }
  });

  return result;
};

export const getFieldErrorNames = (formikErrors: FormikErrors<any>) => {
  return transformObjectToDotNotation(formikErrors);
};

interface ScrollToFieldErrorProps {
  formRef?: React.RefObject<HTMLFormElement | null>;
}

const ScrollToFieldError: React.FunctionComponent<ScrollToFieldErrorProps> = ({ formRef }) => {
  const { submitCount, isValid, errors } = useFormikContext();

  React.useEffect(() => {
    if (isValid) return;

    const fieldErrorNames = getFieldErrorNames(errors);
    if (fieldErrorNames.length <= 0) return;
    const container = formRef?.current ?? document;

    const element = container.querySelector(`input[name='${fieldErrorNames[0]}']`);
    if (!element) return;

    // Scroll to first known error into view
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [submitCount]);

  return null;
};

export default React.memo(ScrollToFieldError);
